export default "__VITE_ASSET__9e79ac01__"